module.exports = "<select\n    ng-model=\"AssignedToFilterCtrl.assignedTo\"\n    ng-options=\"item.user as item.last_name + ' ' + item.first_name for item in AssignedToFilterCtrl.users\"\n>\n    <option value=\"\">Przypisano do</option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/filters/assigned-to-filter/assigned-to-filter.html
// module id = 617
// module chunks = 0